import React, { useState, useEffect } from "react";
import * as Constants from "../../../constants/Constants";
import axios from "../../../service/axios";
import Cookie from "js-cookie";
import LoadingOverlay from "react-loading-overlay";
import { Row, Col } from "react-bootstrap";
import "./MyTeamVendors.css";

const getDashboardValues = (myTasks, wfs) => {
  let workflowSteps = { ...wfs };

  const typeOfPlatform = myTasks.typeOfPlatform;
  const role = myTasks.role;

  let statusArrayBasedOnOwner = [];
  for (const [key, value] of Object.entries(workflowSteps)) {
    let statusName;
    let statusOrder;
    if (value && Array.isArray(value) && value.includes(role)) {
      statusName = key.split("StatusOwner")[0];
      statusOrder = workflowSteps[`${statusName}StatusOrder`];
      statusArrayBasedOnOwner.push({
        statusName,
        statusOrder,
      });
    }
  }
  let myTasksArray = [];
  let labelsArr = [];
  let ordersArr = [];

  statusArrayBasedOnOwner.forEach((x) => {
    let label = Constants.DASHBOARD_TILES_CONSTANTS[x.statusName];
    let order = x.statusOrder;

    if (label && order) {
      if (role === "Merchant") {
        labelsArr.push(label);
        ordersArr.push(order);
        if (
          ["qualityLeaderApproval", "itemOrSkuSetup"].includes(x.statusName)
        ) {
          if (typeOfPlatform === "directEdiRDS") {
            myTasksArray.push({
              key: label,
              value: myTasks[x.statusName],
              displayOrder: order,
            });
          }
        } else {
          myTasksArray.push({
            key: label,
            value: myTasks[x.statusName],
            displayOrder: order,
          });
        }
      }
      if (role === "Ops") {
        labelsArr.push(label);
        ordersArr.push(order);
        if (typeOfPlatform === "directEdiRDS") {
          if (x.statusName !== "bossAgreement") {
            myTasksArray.push({
              key: label,
              value: myTasks[x.statusName],
              displayOrder: order,
            });
          }
        }
        if (
          (typeOfPlatform === "chub" || typeOfPlatform === "directEdi") &&
          ![
            "tableSetup",
            "qualityLeaderApproval",
            "evpAndErpSetup",
            "itemOrSkuSetup",
          ].includes(x.statusName)
        ) {
          myTasksArray.push({
            key: label,
            value: myTasks[x.statusName],
            displayOrder: order,
          });
        }
        if (typeOfPlatform === "multi") {
          myTasksArray.push({
            key: label,
            value: myTasks[x.statusName],
            displayOrder: order,
          });
        }
      }
      if (role === "AP") {
        labelsArr.push(label);
        ordersArr.push(order);

        // Next step DVN Audit
        if (x.statusName === Constants.MY_TASK_DVN_AUDIT) {
          myTasksArray.push({
            key: label,
            value: myTasks[x.statusName] || 0,
            displayOrder: order,
          });
        }

        // Next step DVN Setup
        if (x.statusName === Constants.DVN_SET_UP_ID) {
          myTasksArray.push({
            key:
              Constants.DASHBOARD_TILES_CONSTANTS[
                Constants.MY_TASK_DVN_CREATION
              ],
            value: myTasks[Constants.MY_TASK_DVN_CREATION] || 0,
            displayOrder: order,
          });
        }
      }
    }
  });
  if (myTasksArray.length === 0 && labelsArr.length > 0) {
    labelsArr.forEach((label, i) => {
      if (label) {
        myTasksArray.push({
          key: label,
          value: 0,
          displayOrder: ordersArr[i],
        });
      }
    });
  }
  return myTasksArray.sort((x, y) => {
    if (x.displayOrder < y.displayOrder) return -1;
    if (x.displayOrder > y.displayOrder) return 1;
    return 0;
  });
};

const getColSpan = (role) => {
  if (role === "Merchant" || role === "Vendor") {
    return 7;
  } else if (role === "AP") {
    return 4;
  } else {
    return 10;
  }
};

const MyTeamBoard = ({ workflowSteps }) => {
  const [isTaskLoading, setIsTaskLoading] = useState(false);
  const [myTasks, setMyTasks] = useState(null);

  useEffect(() => {
    setIsTaskLoading(true);

    axios()
      .get(`merchant/myTask/${Cookie.get("email")}`)
      .then((response) => {
        setMyTasks(response.data);
        setIsTaskLoading(false);
      })
      .catch((error) => {
        console.error("Error fetching my task count");
        setIsTaskLoading(false);
      });
  }, []);
  return (
    <Row style={{ paddingLeft: "0" }}>
      <Col xs={myTasks ? getColSpan(myTasks.role) : 8}>
        <LoadingOverlay active={isTaskLoading} spinner>
          <div className="myTeamVendors-container">
            <div className="myTeamVendors-title-container">
              <p className="myTeamVendors-title">{Constants.MY_TASKS}</p>
            </div>
            <ul className="myTeamVendors-status-container">
              {!isTaskLoading &&
                myTasks &&
                [...getDashboardValues(myTasks, workflowSteps)].map(
                  (status, index) => (
                    <li
                      className="myTeamVendors-status-tile"
                      key={index}
                      data-testid="myTeamVendors-status-item"
                    >
                      <div className="myTeamVendors-status-tile-text">
                        {status.value}
                      </div>
                      <div className="myTeamVendors-status-tile-value">
                        {status.key}
                      </div>
                    </li>
                  )
                )}
            </ul>
          </div>
        </LoadingOverlay>
      </Col>
    </Row>
  );
};

export default MyTeamBoard;
